import { render, staticRenderFns } from "./WaysSummaryReport.vue?vue&type=template&id=5c548afa"
import script from "./WaysSummaryReport.vue?vue&type=script&lang=js"
export * from "./WaysSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports